import damMapIcon2 from "./images/icon-map-dam-cotton.png";
import windTurbineMapIcon2 from "./images/icon-map-wind-turbine-cotton.png";
import solarPanelMapIcon2 from "./images/icon-map-solar-panel-cotton.png";
import geothermalIcon from "./images/icons/geothermal.png";
import solidBiomassIcon from "./images/icons/solid-biomass.png"
import boltMapIcon2 from "./images/icon-map-bolt-cotton.png";
import factoryMapIcon2 from "./images/icon-map-factory-cotton.png";

import calendarIcon from "./images/icons/calendar.png";
import chartIcon from "./images/icons/chart.png";
import boltIcon from "./images/icons/bolt.png";
import charityIcon from "./images/icons/charity.png";
import doughnutIcon from "./images/icons/doughnut.png";
import graphReportIcon from "./images/icons/graph-report.png";
import filterIcon from "./images/icons/filter.png";
import infoIcon from "./images/icons/info.png";
import placeIcon from "./images/icons/place.png";
import routeIcon from "./images/icons/route.png";
import vanIcon from "./images/icons/van.png";
import readIcon from "./images/icons/read.png";
import houseIcon from "./images/icons/house.png";
import treeIcon from "./images/icons/tree.png";
import moneyIcon from "./images/icons/money.png";
import listIcon from "./images/icons/list.png";
import nuclearPowerPlantIcon from "./images/icons/nuclear-power-plant.png";

import * as car from "./lottie/car.json";
import * as aroundWorldPlane from "./lottie/around-world-plane-2.json";

const images = {
  damMapIcon2,
  windTurbineMapIcon2,
  solarPanelMapIcon2,
  geothermalIcon,
  solidBiomassIcon,
  boltMapIcon2,
  factoryMapIcon2
};

const icons = {
  calendarIcon,
  chartIcon,
  boltIcon,
  charityIcon,
  doughnutIcon,
  graphReportIcon,
  filterIcon,
  infoIcon,
  placeIcon,
  routeIcon,
  vanIcon,
  readIcon,
  houseIcon,
  treeIcon,
  nuclearPowerPlantIcon,
  moneyIcon,
  listIcon
};

const lottie = {
  car,
  aroundWorldPlane
}

export const assets = {
  images,
  icons,
  lottie
};



// WEBPACK FOOTER //
// ./src/assets/index.js